import React from "react";
import { Avatar, Box, Chip } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const ChipOutlinedColor = () => {
  const handleClick = () => {
    console.log("On Click");
  };
  const handleDelete = () => {
    console.log("On Delete");
  };
  return (
    <Box mb={2}>
      <PreviewAndEditor
        title={"Basic Outlined Chip colors"}
        language={"js"}
        value={"        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Default color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Primary color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"primary\"\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Secondary color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"secondary\"\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Error color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"error\"\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Warning color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"warning\"\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Info color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"info\"\n" +
            "          onClick={handleClick}\n" +
            "        />\n" +
            "        <Chip\n" +
            "          variant=\"outlined\"\n" +
            "          label=\"Success color\"\n" +
            "          avatar={<Avatar>H</Avatar>}\n" +
            "          onDelete={handleDelete}\n" +
            "          color=\"success\"\n" +
            "          onClick={handleClick}\n" +
            "        />"}
      >
        <Chip
          variant="outlined"
          label="Default color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          onClick={handleClick}
        />
        <Chip
          variant="outlined"
          label="Primary color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          color="primary"
          onClick={handleClick}
        />
        <Chip
          variant="outlined"
          label="Secondary color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          color="secondary"
          onClick={handleClick}
        />
        <Chip
          variant="outlined"
          label="Error color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          color="error"
          onClick={handleClick}
        />

        <Chip
          variant="outlined"
          label="Warning color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          color="warning"
          onClick={handleClick}
        />

        <Chip
          variant="outlined"
          label="Info color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          color="info"
          onClick={handleClick}
        />
        <Chip
          variant="outlined"
          label="Success color"
          avatar={<Avatar>H</Avatar>}
          onDelete={handleDelete}
          color="success"
          onClick={handleClick}
        />
      </PreviewAndEditor>
    </Box>
  );
};

export default ChipOutlinedColor;
